import React, {useEffect, useState} from 'react';

import styles from './MobileDeliveryPickup.module.css'
import {Button} from "../../../../../../../ui/General/Button/Button.tsx";
import {Icon} from "../../../../../../../ui/General/Icon/Icon.tsx";
import {Input} from "../../../../../../../ui/DataEntry/Input/Input.tsx";
import {
    PickupPointItem
} from "../../../../../../../widgets/Delivery/components/PickupPointModal/components/PickupPointList/PickupPointItem/PickupPointItem.tsx";
import {MobileModal} from "../../../../../../../ui/Modal/mobile/MobileModal.tsx";
import {Order} from "../../../../../../../types/Order.interface.ts";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
import {
    PickupPoint
} from "../../../../../../../widgets/Delivery/components/PickupPointModal/components/PickupPointList/PickupPointItem/types/PickupPoint.interface.ts";
// import {useLocalStorage} from "../../../../../../../hooks/useLocalStorage.ts";
import {changeCurrentBranch} from "../../../../../../../utils/changeLocation.ts";
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { setSelectedPickPoint, setUserInfoField } from '@/utils/storage/slices/userSlice.ts';
// import { useMultiStorage } from '../../../../../../../hooks/useStorage.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { userInfoLoader } from '@/utils/storage/extra/loaders/user/userInfoLoader.ts';

export const MobileDeliveryPickup: React.FC = () => {
    // const  {getStorageValue, setStorageValue} = useLocalStorage();
    const dispatch = useAppDispatch();
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId);
    const [offer, setOffer] = useState<Order|null>(null);
    const [isListDisplayed, setIsListDisplayed] = useState<boolean>(false)
    const [isMapShown, setIsMapShown] = useState(false)
    const [centerMapCoordinates, setCenterMapCoordinates] = useState<[number, number]>([43.136782, 131.930598]);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    // const [_, setStorage] = useMultiStorage({
    //     branchId: ['branchId', getStorageValue('branchId')],
    //     getUserData: ['getUserData', false],
    //     getCartOffer: ['getCartOffer', false],
    //     cartOffer: ['cartOffer', offer],
    // });

    useEffect(() => {
        if (isListDisplayed) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };

    }, [isListDisplayed]);

    const changeBranch = (point: PickupPoint) => {
        dispatch(setSelectedPickPoint(point.id));
        // setStorageValue('selectedPickPoint', point.id);
        changeCurrentBranch(point.id);
        setTimeout(function () {
            dispatch(setUserInfoField({name: 'branchId', value: point.id}));
            dispatch(userInfoLoader());
            dispatch(cartOfferLoader({cartId: cartId || 0, isMini: false, all: true}));
            // setStorage('branchId', point.id);
            // setStorage('getUserData', true);
            // setStorage('getCartOffer', true);
            close();
        }, 1000);
    }

    const changeCheckedPickPoint = (point: PickupPoint) => {
        // setStorageValue('currentBranchId', point.id);
        dispatch(setUserInfoField({name: 'branchId', value: point.id}));
        offer?.accessibilityBranches.map((branch: PickupPoint) => {
            if(branch.id === point.id && branch.latitude && branch.longitude) setCenterMapCoordinates([branch.latitude, branch.longitude]);
        })
    }

    useEffect(() => {
        
    }, [offer]);

    useEffect(() => {
        if(cartOffer) {
            setOffer(cartOffer);
            if(cartOffer.delivery.point.latitude && cartOffer.delivery.point.longitude) {
                setCenterMapCoordinates([cartOffer.delivery.point.latitude, cartOffer.delivery.point.longitude]);
            }
        }
    }, [cartOffer]);

    if(!offer) return null;

    const workingHours = offer.delivery.point.schedule.split(',');

    return (<div className={styles.wrapper}>
        <h4 className={styles.title}>
            Выбранный пункт самовывоза:
        </h4>
        <div>
            <div className={styles.name}>
                Пункт выдачи {offer.delivery.point.townName}
            </div>
            <div className={styles.address}>
                {offer.delivery.point.address}
            </div>
        </div>
        <div className={styles.schedule}>
            {workingHours.map((hours) => {
                return <div>{hours}</div>
            })}
        </div>
        <div className={styles.buttons}>
            <Button type='regular' className={styles.btnChoosePoint} onClick={() => setIsListDisplayed(true)}>
                Выбрать другой
            </Button>
            <Button className={styles.btnOpenMap} type='text' onClick={() => setIsMapShown(!isMapShown)}>
                Открыть карту
            </Button>
        </div>

        {isListDisplayed && (
            <MobileModal
                isOpen={isListDisplayed}
                title='Найдите ближайший пункт выдачи'
                close={() => setIsListDisplayed(false)}
            >
                <div className={styles.modalChoosePointWrapper}>
                    <Input
                        icon={<Icon name='search' width={18} height={18} color='#9a9a9a'/>}
                        className={styles.choosePointInput} placeholder='Искать пункт выдачи'
                    />
                    <ul className={styles.pointList}>
                        {offer.accessibilityBranches.map((point) => (
                            <li className={styles.item} key={point.id}>
                                <PickupPointItem
                                    point={point}
                                    currentTownId={offer.delivery.townId}
                                    changeCheckedPickPoint={changeCheckedPickPoint}
                                    choosePickPoint={changeBranch}
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            </MobileModal>
        )}

        {isMapShown && (
            <MobileModal
                isOpen={isMapShown}
                title={<div>
                    <div>{offer.delivery.point.address}</div>
                    <div>(Пункт выдачи {offer.delivery.point.townName})</div>
                </div>}
                close={() => setIsMapShown(false)}
            >
                {/* здесь должна быть интерактивная карта   */}
                <div className={styles.mapWrapper}>
                    {offer.accessibilityBranches.length ?
                        (<YMaps>
                            <Map
                                defaultState={{
                                    zoom: 14,
                                    controls: [],
                                    center: centerMapCoordinates,
                                }}
                                width="100%"
                                height={485}
                            >
                                {offer.accessibilityBranches.map(branch => {
                                    if(!branch.latitude || !branch.longitude) return null;

                                    return  <Placemark
                                        modules={["geoObject.addon.balloon"]}
                                        key={branch.id}
                                        defaultGeometry={[branch.latitude, branch.longitude]}
                                        properties={{
                                            balloonContentBody:`<div><div>Адрес: ${branch.address}</div></div>`
                                        }}
                                        onClick={() => changeBranch(branch)}
                                    />
                                })}
                            </Map>
                        </YMaps>) : null}
                </div>
            </MobileModal>
        )}
    </div>);
};
